define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/nls/zh-tw/connectionMonitor"
,"scramble/nls/zh/connectionMonitor"
,"scramble/nls/ja/connectionMonitor"
,"scramble/nls/fr/connectionMonitor"
,"scramble/nls/de/connectionMonitor"
,"scramble/nls/ko/connectionMonitor"
,"scramble/nls/it/connectionMonitor"
,"scramble/nls/cs/connectionMonitor"
,"scramble/nls/tr/connectionMonitor"
,"scramble/nls/pl/connectionMonitor"
,"scramble/nls/fi/connectionMonitor"
,"scramble/nls/hu/connectionMonitor"
,"scramble/nls/sk/connectionMonitor"
,"scramble/nls/en-gb/connectionMonitor"
,"scramble/nls/nb/connectionMonitor"
,"scramble/nls/es/connectionMonitor"
,"scramble/nls/nl/connectionMonitor"
,"scramble/nls/pt/connectionMonitor"
,"scramble/nls/ru/connectionMonitor"
,"scramble/nls/sv/connectionMonitor"
,"/home/semaphore/scramble4/src/scramble/nls/connectionMonitor.js?absMid=scramble/nls/connectionMonitor"
], function(loader, runner) {
   return runner(loader, "scramble/nls/connectionMonitor", __webpack_require__.dj.c(), false);
});